<template>
  <div>
    <v-select
      v-model="input"
      :rules="requiredRule"
      :items="values"
      :label="customField.label + (required ? ' *' : '')"
      :hint="customField.hint"
      :disabled="disabled"
      :loading="loading"
      :placeholder="customField.placeholder"
      :clearable="!required"
      persistent-hint
      outlined
      multiple
    >
      <template #selection="{ item }">
        <custom-field-value-chip :value="item" />
      </template>
      <template #item="{ item }">
        <v-list-item-content>
          <v-list-item-title>
            <div style="display: flex">
              <v-sheet rounded="pill" :color="`${item.color} lighten-3`" class="mr-1 mb-n1" height="18" width="18" />
              {{ item.value }}
            </div>
          </v-list-item-title>
          <v-list-item-subtitle>{{ item.description }} </v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </v-select>

    <debug>
      {{ value }}
    </debug>
  </div>
</template>

<style></style>

<script lang="ts">
import { requiredRuleArray } from "@/lib/rules/requiredRule";
import { Component } from "vue-property-decorator";
import Debug from "../utility/Debug.vue";
import CustomFieldText from "./CustomFieldText.vue";
import CustomFieldValueChip from "./CustomFieldValueChip.vue";

@Component({
  components: { CustomFieldValueChip, Debug }
})
export default class CustomFieldMultiSelect extends CustomFieldText {
  /** `requiredRule` accepts an empty array */
  get requiredRule() {
    if (this.required) {
      return [requiredRuleArray()];
    }
    return [];
  }

  get values() {
    return this.customField.configuration?.values ?? [];
  }

  get input(): string[] {
    if (typeof this.value === "string") {
      return [this.value];
    }

    return this.value;
  }

  set input(v: string[]) {
    this.$emit("input", v);
  }
}
</script>
